import React from 'react';
import { useSelector } from 'react-redux';
import { constants, verifiers } from '@yola/subscription-manager-js';
import redirectToUrl from 'src/js/utils/redirect-to-url';
import PaywallContainer from '../../modules/paywall/containers/paywall-container';
import useSupportedSearchParams from '../hooks/use-supported-search-params';
import user from '../../modules/user';
import utils from '../../modules/webapp-plugins/utils';

const { DOMAIN_SUBSCRIPTION } = constants.SubscriptionType;

function PaywallRoute() {
  const searchParams = useSupportedSearchParams();
  const isB2C = useSelector(user.selectors.getIsB2C);

  if (!searchParams) return null;

  const {
    initiator,
    products = [],
    term,
    domain,
    premiumFeature,
    triggerId,
    actionId,
    back,
    periodToggle,
    paymentBackUrl,
  } = searchParams;
  const hasProducts = Boolean(products.length);
  const isPaidHostingProduct = hasProducts && verifiers.hasPaidHostingPackageType(products);

  if (isPaidHostingProduct) {
    const domainProduct = domain ? [DOMAIN_SUBSCRIPTION] : [];

    redirectToUrl(
      utils.generatePaymentUrl(
        {
          products: [...products, ...domainProduct],
          ...(domain && { domain_name: domain }),
          ...(initiator && { initiator }),
          ...(paymentBackUrl && { backUrl: paymentBackUrl }),
          ...(term && { term }),
        },
        isB2C
      )
    );

    return null;
  }

  const propsFromSearchParams = {
    ...(initiator && { initiator }),
    ...(premiumFeature && { premiumFeature }),
    ...(domain && { domain }),
    ...(hasProducts && { extraProducts: products }),
    ...(term && { term }),
    ...(triggerId && { triggerId }),
    ...(actionId && { actionId }),
    ...(back && { backUrl: back }),
    ...(paymentBackUrl && { paymentBackUrl }),
    periodToggle: periodToggle !== false,
  };

  return <PaywallContainer {...propsFromSearchParams} />;
}

export default PaywallRoute;
